import coverImg from '../../../media/papers/allosteric/cover.png';
import allostericPDF from '../../../media/papers/allosteric/Verk.pdf';


const allostericPaperData = {
    name: "Predicting and Decoding Allosteric Binding",
    displayTitle: "Predicting and Decoding\nAllosteric Binding",
    category: "Computational Biology",
    tagline: "Protein language models and energy landscape frustration explain the allosteric blind spot in kinase binding site prediction",
    year: "2026",
    format: "JCTC",
    heroImage: coverImg,

    description: "Reliable identification of allosteric binding sites remains a major challenge in structure-based drug discovery, particularly in protein kinases where these sites are structurally cryptic and poorly conserved. Using 453 human kinase-ligand complexes, this study integrates fine-tuned ESM2-650M, P2Rank detection, and local frustration analysis. Both approaches perform well on orthosteric sites, but PLM performance declines substantially on allosteric sites, consistent with minimally frustrated orthosteric pockets and neutral frustration at allosteric sites.",

    highlight: "The allosteric blind spot reflects intrinsic biophysical design: neutral frustration at allosteric sites versus minimally frustrated orthosteric pockets, not algorithmic limitations alone.",

    techStack: [
        "ESM2 (PLM)",
        "P2Rank",
        "Local Frustration Analysis",
        "Energy Landscape Theory",
        "Human Kinases (n=453)",
        "Explainable AI",
        "Computational Biology"
    ],

    documents: [
        {
            type: 'link',
            src: 'https://pubs.acs.org/doi/10.1021/acs.jctc.6c00427',
            title: 'View in J. Chem. Theory Comput.',
            alt: 'Peer-reviewed journal article'
        },
        {
            type: 'pdf',
            src: allostericPDF,
            title: 'Read Full Paper (PDF)',
            alt: 'Full research paper'
        },
        {
            type: 'link',
            src: "https://www.biorxiv.org/content/10.64898/2026.01.05.697819v1",
            title: 'View on bioRxiv',
            alt: 'Original preprint'
        }
    ],
    documentTitle: "Publication"
};

export default allostericPaperData;
